/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrValue, PhrValueFromJSON, PhrValueFromJSONTyped, PhrValueToJSON } from "./";

export const PhrAbdominalCircumferenceTypename = "PhrAbdominalCircumference" as const;

/**
 *
 * @export
 * @interface PhrAbdominalCircumference
 */
export interface PhrAbdominalCircumference {
  /**
   *
   * @type {PhrValue}
   * @memberof PhrAbdominalCircumference
   */
  mySelfMeasurement?: PhrValue;
  /**
   *
   * @type {PhrValue}
   * @memberof PhrAbdominalCircumference
   */
  mySelfReport?: PhrValue;
  /**
   *
   * @type {PhrValue}
   * @memberof PhrAbdominalCircumference
   */
  value?: PhrValue;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrAbdominalCircumference
   */
  readonly __typename?: string;
}

export function PhrAbdominalCircumferenceFromJSON(json: any): PhrAbdominalCircumference {
  return PhrAbdominalCircumferenceFromJSONTyped(json, false);
}

export function PhrAbdominalCircumferenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PhrAbdominalCircumference {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrAbdominalCircumferenceTypename,

    mySelfMeasurement: !exists(json, "my_self_measurement") ? undefined : PhrValueFromJSON(json["my_self_measurement"]),
    mySelfReport: !exists(json, "my_self_report") ? undefined : PhrValueFromJSON(json["my_self_report"]),
    value: !exists(json, "value") ? undefined : PhrValueFromJSON(json["value"]),
  };
}

export function PhrAbdominalCircumferenceToJSON(object?: PhrAbdominalCircumference | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    my_self_measurement: PhrValueToJSON(value.mySelfMeasurement),
    my_self_report: PhrValueToJSON(value.mySelfReport),
    value: PhrValueToJSON(value.value),
  };
}
